import user from './user'
import year from './year'
import family from './family'
import course from './course'
import schedule from './schedule'
import enrollment from './enrollment'
import dom from './dom'
import odoo from './odoo'

export default {
  user,
  dom,
  odoo,
  year,
  course,
  enrollment,
  schedule,
  family
}
